export default __webpack_public_path__ + "static/media/1.4639d5b8.jpeg";